import { render, staticRenderFns } from "./SupportComments.vue?vue&type=template&id=fe97c038&scoped=true"
import script from "./SupportComments.vue?vue&type=script&lang=js"
export * from "./SupportComments.vue?vue&type=script&lang=js"
import style0 from "./supportList.css?vue&type=style&index=0&id=fe97c038&prod&scoped=true&lang=css&external"
import style1 from "./SupportComments.vue?vue&type=style&index=1&id=fe97c038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe97c038",
  null
  
)

export default component.exports